/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ailoaderstepanalysing3Inputs */

const en_ailoaderstepanalysing3 = /** @type {(inputs: Ailoaderstepanalysing3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysing your request`)
};

const de_ailoaderstepanalysing3 = /** @type {(inputs: Ailoaderstepanalysing3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfrage wird analysiert`)
};

/**
* | output |
* | --- |
* | "Analysing your request" |
*
* @param {Ailoaderstepanalysing3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ailoaderstepanalysing3 = /** @type {((inputs?: Ailoaderstepanalysing3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ailoaderstepanalysing3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ailoaderstepanalysing3(inputs)
	return de_ailoaderstepanalysing3(inputs)
});
export { ailoaderstepanalysing3 as "aiLoaderStepAnalysing" }